import { Link } from "react-router-dom";

function PrivacyPolicy() {
    return (
        <div className="policy-container">
            <h1>QAPfinancials Privacy Policy</h1>
            <p><strong>Effective Date:</strong> September 21, 2025</p>
            <p>
            QAPfinancials LLC (“Company,” “we,” “our,” or “us”) values your privacy. 
            This Privacy Policy explains how we collect, use, disclose, and protect 
            your information when you use our software and services that connect to QuickBooks.
            </p>
            <p><strong>1. Information We Collect</strong></p>
            <p>When you use our software, we may collect the following types of information:
                <ul>
                    <li>Account Information: Name, email address, company details, and login credentials.</li>
                    <li>Financial Data: With your permission, we access data from QuickBooks such as transaction records, account balances, invoices, payroll, and related financial information.</li>
                    <li>Usage Data: Log files, IP address, device information, and activity within our application.</li>
                    <li>Support Information: Information you provide when contacting customer support.</li>
                </ul>
            </p>
            <p><strong>2. How We Use Your Information</strong></p>
            <p>We use the information we collect to:
                <ul>
                    <li>Provide, operate, and improve our software.</li>
                    <li>Connect and sync data with QuickBooks.</li>
                    <li>Troubleshoot issues and provide customer support.</li>
                    <li>Communicate updates, changes, and important notices.</li>
                    <li>Maintain security and prevent fraud.</li>
                    <li>Comply with applicable laws and regulations.</li>
                </ul>
            </p>
            <p><strong>3. How We Share Your Information</strong></p>
            <p>We do not sell your personal or financial information. We may share data in the following limited circumstances:
                <ul>
                    <li>With QuickBooks (Intuit Inc.) to facilitate integration and data exchange.</li>
                    <li>With Service Providers that help us operate the platform (e.g., hosting, analytics, customer support).</li>
                    <li>For Legal Reasons if required by law, regulation, or legal process.</li>
                    <li>In Business Transfers if we are involved in a merger, acquisition, or sale of assets.
                    </li>
                </ul>
            </p>
            <p><strong>4. Data Security</strong></p>
            <p>We use administrative, technical, and physical safeguards to protect your data. While we strive to use commercially reasonable measures, no system is completely secure.</p>
            <p><strong>5. Data Retention</strong></p>
            <p>We retain your information only as long as necessary to provide our services, comply with legal obligations, or resolve disputes. </p>
            <p><strong>6. Your Rights</strong></p>
            <p>Depending on your location, you may have rights to:
                <ul>
                    <li>Access, correct, or delete your information.</li>
                    <li>Restrict or object to certain data processing.</li>
                    <li>Withdraw consent at any time.</li>
                    <li>File a complaint with your local data protection authority.</li>
                </ul>
            </p>
            <p><strong>7. Third-Party Services</strong></p>
            <p>Our service relies on QuickBooks and may contain links to other third-party services. We are not responsible for their privacy practices.</p>
            <p><strong>8. Children’s Privacy</strong></p>
            <p>Our software is not directed to individuals under 18. We do not knowingly collect data from children.</p>
            <p><strong>9. Updates to This Privacy Policy</strong></p>
            <p>We may update this Privacy Policy from time to time. Updates will be posted with a revised “Effective Date.”</p>
            <p><strong>10. Contact Us</strong></p>
            <p>If you have any questions, please contact us at:
                <p>Noah Isaacs</p>
                <p>noahbisaacs@gmail.com</p>
                <p>31-00 Broadway 3rd Floor, Fair Lawn NJ 07410</p>
            </p>
            <Link to="/" className="home-link">Go Back Home</Link>
            
        </div>
  )
}

export default PrivacyPolicy;